import gql from 'graphql-tag';

export default gql`
  mutation notificationRegister($input: NotificationRegisterInput!) {
    notificationRegister(input: $input) {
      id
    }
  }
`;
